import { render, staticRenderFns } from "./RecommendList.vue?vue&type=template&id=c0d84f8a&scoped=true&"
import script from "./RecommendList.vue?vue&type=script&lang=js&"
export * from "./RecommendList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendList.vue?vue&type=style&index=0&id=c0d84f8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d84f8a",
  null
  
)

export default component.exports